<div class="home-main" [ngStyle]="get_style()">
  <div class="home-wrp">
    <div class="home-content">
      <div class="login-btn" *ngIf="!user_id">
        <button class="primary-btn svg-left" (click)="AccountPopup.openModal()">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g transform="translate(2.3 0) skewX(-12)" fill="none">
              <mask id="pr-logo-mask-signin" maskUnits="userSpaceOnUse" x="-5" y="-5" width="30" height="30">
                <rect x="-5" y="-5" width="30" height="30" fill="white" />
                <path d="M4 15.5V2h4.75a3.75 3.75 0 0 1 0 7.5H4" stroke="black" stroke-width="3.6" />
              </mask>
              <path d="M7.5 18.5V5.5h4a3.5 3.5 0 0 1 0 7h-4M11 12.5l3.5 6" mask="url(#pr-logo-mask-signin)" />
              <path d="M4 15.5V2h4.75a3.75 3.75 0 0 1 0 7.5H4" />
            </g>
          </svg>

          {{ helper.button.se_connecter | translate }}
        </button>
      </div>
      <div class="login-btn after-login" *ngIf="user_id">
        <button class="primary-btn svg-left only-svg">
          <svg
            width="20"
            height="19"
            viewBox="0 0 20 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.76807 0.351929C8.43606 0.351929 7.39542 0.842182 6.64617 1.82269C5.89691 2.80319 5.52229 4.05658 5.52229 5.58284C5.51304 7.4791 6.12354 8.98224 7.3538 10.0922C7.51105 10.2402 7.56655 10.4299 7.5203 10.6611L7.20117 11.3271C7.09942 11.5491 6.94911 11.7226 6.75023 11.8474C6.55136 11.9723 6.13279 12.1504 5.49454 12.3816C5.46679 12.3909 4.88172 12.5805 3.73934 12.9505C2.59695 13.3205 1.98876 13.524 1.91476 13.561C1.13776 13.8848 0.629004 14.2224 0.388503 14.5739C0.129501 15.1567 0 16.632 0 19.0001H19.5361C19.5361 16.632 19.4066 15.1567 19.1476 14.5739C18.9071 14.2224 18.3984 13.8848 17.6214 13.561C17.5474 13.524 16.9392 13.3205 15.7968 12.9505C14.6544 12.5805 14.0693 12.3909 14.0416 12.3816C13.4033 12.1504 12.9848 11.9723 12.7859 11.8474C12.587 11.7226 12.4367 11.5491 12.335 11.3271L12.0158 10.6611C11.9696 10.4299 12.0251 10.2402 12.1823 10.0922C13.4126 8.98224 14.0231 7.4791 14.0138 5.58284C14.0138 4.05658 13.6392 2.80319 12.89 1.82269C12.1407 0.842182 11.1001 0.351929 9.76807 0.351929Z"
            />
          </svg>
        </button>
        <app-profile-menu></app-profile-menu>
      </div>

      <div
        class="home-content-main v-scroll-hide store-close"
        *ngIf="
          !helper.website_data.detail.is_business ||
          !helper.website_data.detail.is_approved
        "
      >
        <div class="home-title">
          <span>
            <svg
              width="36"
              height="34"
              viewBox="0 0 36 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M35.0719 27.0589L21.5857 2.21889C21.2287 1.56287 20.7014 1.01526 20.0593 0.63371C19.4172 0.252158 18.6842 0.0507812 17.9373 0.0507812C17.1904 0.0507812 16.4573 0.252158 15.8153 0.63371C15.1732 1.01526 14.6459 1.56287 14.2888 2.21889L0.788817 27.0589C0.43547 27.6931 0.254528 28.4089 0.264028 29.1349C0.273527 29.8608 0.473136 30.5716 0.842958 31.1964C1.21278 31.8212 1.7399 32.3381 2.37177 32.6957C3.00364 33.0532 3.71819 33.2389 4.4442 33.2343H31.4165C32.1366 33.2349 32.8444 33.0484 33.4707 32.693C34.0969 32.3375 34.62 31.8254 34.9886 31.2069C35.3572 30.5883 35.5587 29.8846 35.5733 29.1647C35.5879 28.4448 35.4151 27.7334 35.0719 27.1004V27.0589ZM15.8673 9.33581C15.8673 8.78497 16.0861 8.2567 16.4756 7.8672C16.8651 7.4777 17.3934 7.25889 17.9442 7.25889C18.495 7.25889 19.0233 7.4777 19.4128 7.8672C19.8023 8.2567 20.0211 8.78497 20.0211 9.33581V18.8758C20.0211 19.4266 19.8023 19.9549 19.4128 20.3444C19.0233 20.7339 18.495 20.9527 17.9442 20.9527C17.3934 20.9527 16.8651 20.7339 16.4756 20.3444C16.0861 19.9549 15.8673 19.4266 15.8673 18.8758V9.33581ZM17.9996 28.042C17.5286 28.042 17.0681 27.9023 16.6765 27.6406C16.2848 27.3789 15.9796 27.007 15.7993 26.5718C15.6191 26.1366 15.5719 25.6578 15.6638 25.1958C15.7557 24.7338 15.9825 24.3095 16.3156 23.9764C16.6486 23.6434 17.073 23.4165 17.535 23.3246C17.9969 23.2328 18.4758 23.2799 18.911 23.4602C19.3461 23.6404 19.7181 23.9457 19.9798 24.3373C20.2414 24.729 20.3811 25.1894 20.3811 25.6604C20.3811 26.292 20.1302 26.8978 19.6836 27.3444C19.237 27.7911 18.6312 28.042 17.9996 28.042Z"
                fill="#FF3434"
              />
            </svg>
          </span>
          <h4>
            {{
              current_store.whop_store_name
                ? current_store.whop_store_name
                : current_store.name
            }}
            {{ helper.title.da_gabriele_est_ferme | translate }}
          </h4>
        </div>
        <div class="command-not-available">
          <p>{{ helper.text.command_not_available | translate }}</p>
        </div>
        <div class="home-cont-mid">
          <h3>{{ helper.text.various_orders | translate }}</h3>
          <a href="https://web.pronto-resto.com/">
            <button class="primary-btn">
              web.pronto-resto.com
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.001 16H2.00098C1.47054 16 0.961836 15.7893 0.586763 15.4142C0.21169 15.0391 0.000976563 14.5304 0.000976562 14V3C0.000976562 2.46957 0.21169 1.96086 0.586763 1.58579C0.961836 1.21071 1.47054 1 2.00098 1H6.00098V3H2.00098V14H13.001V10H15.001V14C15.001 14.5304 14.7903 15.0391 14.4152 15.4142C14.0401 15.7893 13.5314 16 13.001 16ZM7.70098 9.707L6.29098 8.293L12.584 2H9.00098V0H16.001V7H14.001V3.415L7.70098 9.707Z"
                />
              </svg>
            </button>
          </a>
        </div>
      </div>

      <div
        class="home-content-main v-scroll-hide"
        *ngIf="
          page_type == 1 &&
          helper.website_data.detail.is_business &&
          helper.website_data.detail.is_approved
        "
      >
        <div
          class="return-btn"
          style="padding-bottom: 0px"
          *ngIf="sub_button_detail"
        >
          <button
            class="primary-btn border-btn svg-left"
            (click)="sub_button_detail = null"
          >
            <svg
              width="10"
              height="15"
              viewBox="0 0 10 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.70211 13.7851C9.26899 14.273 8.52237 14.3174 8.03447 13.8842L1.38114 7.97783C1.1286 7.75365 0.984086 7.43211 0.984086 7.09442C0.984086 6.75674 1.1286 6.4352 1.38114 6.21102L8.03447 0.304611C8.52237 -0.128508 9.26899 -0.0841056 9.70211 0.403787C10.1352 0.891679 10.0908 1.63831 9.60294 2.07142L3.94472 7.09443L9.60294 12.1174C10.0908 12.5505 10.1352 13.2972 9.70211 13.7851Z"
              />
            </svg>
            <span>{{ helper.button.retour | translate }}</span>
          </button>
        </div>
        <div class="home-title">
          <h4>{{ current_store.whop_heading_text }}</h4>
          <h1>
            {{
              current_store.whop_store_name
                ? current_store.whop_store_name
                : current_store.name
            }}
          </h1>
          <p
            class="custom-text"
            *ngIf="current_store.is_show_site_desc && current_store.site_desc"
          >
            {{ current_store.site_desc }}
          </p>
        </div>

        <div class="home-cont-mid">
          <div class="home-btn-wrp" *ngIf="!sub_button_detail">
            <button
              class="primary-btn"
              *ngFor="
                let button of current_store.dynamic_buttons;
                let i = index
              "
              (click)="button_action(button, i)"
              (mouseenter)="button.is_hovered = true"
              (mouseleave)="button.is_hovered = false"
              [style.color]="
                button.is_hovered ? button.hover_color : button.color
              "
              [style.background-color]="
                button.is_hovered
                  ? button.hover_background_color
                  : button.background_color
              "
              [style.font-size]="button.font_size + 'px'"
              [style.font-weight]="button.font_weight"
            >
              {{ button.text[helper.website_data.selected_language ?? "en"] }}
            </button>
          </div>
          <div class="home-btn-wrp" *ngIf="sub_button_detail">
            <button
              class="primary-btn"
              *ngFor="
                let button of sub_button_detail.sub_buttons;
                let i = index
              "
              (click)="button_action(button, i)"
              (mouseenter)="button.is_hovered = true"
              (mouseleave)="button.is_hovered = false"
              [style.color]="
                button.is_hovered ? button.hover_color : button.color
              "
              [style.background-color]="
                button.is_hovered
                  ? button.hover_background_color
                  : button.background_color
              "
              [style.font-size]="button.font_size + 'px'"
              [style.font-weight]="button.font_weight"
            >
              {{ button.text[helper.website_data.selected_language ?? "en"] }}
            </button>
          </div>
        </div>
        <div class="home-cont-footer">
          <div class="h-c-footer-img">
            <span
              >{{ helper.text.powered_by | translate }}
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                style="stroke: var(--theme-primary-color)"
                stroke-opacity="0.4"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g transform="translate(2.3 0) skewX(-12)" fill="none">
                  <mask id="pr-logo-mask-footer-1" maskUnits="userSpaceOnUse" x="-5" y="-5" width="30" height="30">
                    <rect x="-5" y="-5" width="30" height="30" fill="white" />
                    <path d="M4 15.5V2h4.75a3.75 3.75 0 0 1 0 7.5H4" stroke="black" stroke-width="3.6" />
                  </mask>
                  <path d="M7.5 18.5V5.5h4a3.5 3.5 0 0 1 0 7h-4M11 12.5l3.5 6" mask="url(#pr-logo-mask-footer-1)" />
                  <path d="M4 15.5V2h4.75a3.75 3.75 0 0 1 0 7.5H4" />
                </g>
              </svg>
            </span>
          </div>
        </div>
      </div>

      <div
        class="home-content-main v-scroll-hide"
        *ngIf="
          page_type == 2 &&
          helper.website_data.detail.is_business &&
          helper.website_data.detail.is_approved
        "
      >
        <div
          class="return-btn"
          style="padding-bottom: 0px"
          *ngIf="
            current_store.is_show_dynamic_buttons &&
            current_store.dynamic_buttons.length > 0
          "
        >
          <button
            class="primary-btn border-btn svg-left"
            (click)="page_type = 1"
          >
            <svg
              width="10"
              height="15"
              viewBox="0 0 10 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.70211 13.7851C9.26899 14.273 8.52237 14.3174 8.03447 13.8842L1.38114 7.97783C1.1286 7.75365 0.984086 7.43211 0.984086 7.09442C0.984086 6.75674 1.1286 6.4352 1.38114 6.21102L8.03447 0.304611C8.52237 -0.128508 9.26899 -0.0841056 9.70211 0.403787C10.1352 0.891679 10.0908 1.63831 9.60294 2.07142L3.94472 7.09443L9.60294 12.1174C10.0908 12.5505 10.1352 13.2972 9.70211 13.7851Z"
              />
            </svg>
            <span>{{ helper.button.retour | translate }}</span>
          </button>
        </div>

        <div class="home-title">
          <h4>{{ current_store.whop_heading_text }}</h4>
          <h1>
            {{
              current_store.whop_store_name
                ? current_store.whop_store_name
                : current_store.name
            }}
          </h1>
          <p
            class="custom-text"
            *ngIf="current_store.is_show_site_desc && current_store.site_desc"
          >
            {{ current_store.site_desc }}
          </p>
        </div>
        <div
          class="close-time"
          *ngIf="
            current_store.close &&
            ((!current_store.is_pickup_possible &&
              helper.common_data.cart_data.ipickup_delivery) ||
              (!current_store.is_delivery_possible &&
                !helper.common_data.cart_data.ipickup_delivery))
          "
        >
          <p *ngIf="current_store.nextopentime">
            {{ helper.title.reopen_at | translate }}
            {{ current_store.nextopentime }}
            <span *ngIf="current_store.is_pickup_possible"
              >Pickup Possible</span
            >
            <span *ngIf="current_store.is_delivery_possible"
              >Delivery Possible</span
            >
          </p>
          <p *ngIf="!current_store.nextopentime">
            <span
              >{{ helper.title.reopen_at | translate }}
              {{ helper.title.store_closed_today }}</span
            >
          </p>
        </div>
        <div
          class="discount-offer"
          *ngIf="!current_store.close && offer_list.length > 0"
        >
          <p *ngFor="let offer_message of offer_list">⭐ {{ offer_message }}</p>
        </div>
        <div class="stop_preorder" *ngIf="current_store.is_only_schedule_order">
          <p>
            <span *ngIf="current_store.is_only_schedule_order"
              >Uniquement en précommande min.
              {{ current_store.only_schedule_order_after_hour }}h à
              l’avance.</span
            >
          </p>
        </div>

        <div class="home-cont-mid">
          <div class="home-btn-wrp">
            <p
              class="pre-order-text"
              *ngIf="
                current_store.close &&
                current_store.nextopentime &&
                !current_store.is_delivery_stop_admin
              "
            >
              {{ helper.text.pre_order_text | translate }}
            </p>
            <p
              class="pre-order-text"
              *ngIf="current_store.is_delivery_stop_admin"
            >
              {{ helper.text.pre_order_text1 | translate }}
            </p>
            <ng-container *ngIf="!helper.common_data.cart_data.is_order_pay">
              <button
                *ngIf="current_store.order_type !== 1"
                (mouseover)="button_hover(2)"
                (mouseout)="button_hover(1)"
                class="primary-btn"
                [class.secondary-btn]="hover_type == 2"
                (click)="go_to_next(false, false)"
              >
                {{ helper.button.en_livraison | translate }}
              </button>
              <button
                *ngIf="current_store.order_type !== 2"
                (mouseover)="button_hover(2)"
                (mouseout)="button_hover(1)"
                class="primary-btn"
                [class.secondary-btn]="current_store.order_type !== 1"
                (click)="go_to_next(true, false)"
              >
                {{ helper.button.en_click_collect | translate }}
              </button>
              <button
                *ngIf="current_store.is_catering_active"
                (mouseover)="button_hover(2)"
                (mouseout)="button_hover(1)"
                class="primary-btn"
                [class.secondary-btn]="current_store.is_catering_active"
                (click)="go_to_next(false, true)"
              >
                {{ helper.button.catering | translate }}
              </button>
            </ng-container>
            <ng-container *ngIf="helper.common_data.cart_data.is_order_pay">
              <div class="table_text1">
                {{ helper.title.table_title | translate }}
              </div>
              <input
                type="text"
                [(ngModel)]="helper.common_data.cart_data.table_no"
                #table_no="ngModel"
                name="table_no"
                class="form-control table_text"
                placeholder="{{ helper.placeholder.table_no | translate }}"
              />
              <button
                class="primary-btn"
                [class.secondary-btn]="hover_type == 2"
                (click)="go_to_next(true, false)"
              >
                {{ helper.button.continuer | translate }}
              </button>
            </ng-container>
            <a
              *ngIf="current_store.menu_url && current_store.is_show_menu_url"
              class="blank_a"
              (click)="go_to_menu()"
              >{{ helper.button.voir_le_menu | translate }}</a
            >
          </div>
        </div>
        <div class="home-cont-footer">
          <div class="h-c-footer-img">
            <span
              >{{ helper.text.powered_by | translate }}
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                style="stroke: var(--theme-primary-color)"
                stroke-opacity="0.4"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g transform="translate(2.3 0) skewX(-12)" fill="none">
                  <mask id="pr-logo-mask-footer-2" maskUnits="userSpaceOnUse" x="-5" y="-5" width="30" height="30">
                    <rect x="-5" y="-5" width="30" height="30" fill="white" />
                    <path d="M4 15.5V2h4.75a3.75 3.75 0 0 1 0 7.5H4" stroke="black" stroke-width="3.6" />
                  </mask>
                  <path d="M7.5 18.5V5.5h4a3.5 3.5 0 0 1 0 7h-4M11 12.5l3.5 6" mask="url(#pr-logo-mask-footer-2)" />
                  <path d="M4 15.5V2h4.75a3.75 3.75 0 0 1 0 7.5H4" />
                </g>
              </svg>
            </span>
          </div>
        </div>
      </div>

      <div
        class="home-content-main v-scroll-hide delivery-add-section"
        *ngIf="page_type == 3"
      >
        <div class="return-btn">
          <button
            class="primary-btn border-btn svg-left"
            (click)="page_type = 2; hover_type = 1"
          >
            <svg
              width="10"
              height="15"
              viewBox="0 0 10 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.70211 13.7851C9.26899 14.273 8.52237 14.3174 8.03447 13.8842L1.38114 7.97783C1.1286 7.75365 0.984086 7.43211 0.984086 7.09442C0.984086 6.75674 1.1286 6.4352 1.38114 6.21102L8.03447 0.304611C8.52237 -0.128508 9.26899 -0.0841056 9.70211 0.403787C10.1352 0.891679 10.0908 1.63831 9.60294 2.07142L3.94472 7.09443L9.60294 12.1174C10.0908 12.5505 10.1352 13.2972 9.70211 13.7851Z"
              />
            </svg>
            <span>{{ helper.button.retour | translate }}</span>
          </button>
        </div>
        <div class="deli-address">
          <div
            class="deli-add-top"
            *ngIf="!helper.common_data.cart_data.ipickup_delivery"
          >
            <h3>{{ helper.text.deli_add_text | translate }}</h3>
            <div class="input-dropdown">
              <form
                action=""
                class="add-control"
                [class.active]="delivery_setting_service.is_show_address"
              >
                <input
                  type="text"
                  (keydown)="delivery_setting_service.is_show_address = true"
                  [(ngModel)]="helper.common_data.cart_data.address"
                  #address="ngModel"
                  id="address"
                  name="address"
                  data-hj-whitelist
                  autocomplete="off"
                  class="form-control"
                  [class.active]="delivery_setting_service.is_show_address"
                  [class.error]="!delivery_setting_service.is_address_valid"
                  placeholder="{{
                    helper.placeholder.deli_address | translate
                  }}"
                />
                <span
                  *ngIf="
                    delivery_setting_service.favourite_addresses.length > 0
                  "
                  class="form-control-svg"
                  (click)="delivery_setting_service.set_show_address()"
                >
                  <svg
                    width="27"
                    height="17"
                    viewBox="0 0 27 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 3L13.5123 14.3209L24.0246 3"
                      stroke-width="3.31967"
                      stroke-linecap="square"
                    />
                  </svg>
                </span>
              </form>
              <div
                class="add-con-dropdown-list v-scroll-hide"
                [class.active]="delivery_setting_service.is_show_address"
                *ngIf="delivery_setting_service.is_show_address"
              >
                <h3>{{ helper.title.vos_adresse_enregistrees | translate }}</h3>
                <div class="address-form-list-main">
                  <form action="">
                    <ng-container
                      *ngFor="
                        let address of delivery_setting_service.favourite_addresses
                          | searchpipe
                            : helper.common_data.cart_data.address
                            : ['address']
                      "
                    >
                      <div
                        class="address-form-list"
                        *ngIf="address.address && address.latitude"
                      >
                        <input
                          (click)="
                            delivery_setting_service.select_address(
                              address,
                              current_store
                            )
                          "
                          type="text"
                          class="form-control"
                          value="{{ address.address }}"
                          placeholder="{{ address.address }}"
                          readonly
                        />
                      </div>
                    </ng-container>
                  </form>
                </div>
              </div>
            </div>

            <div class="deli-area-link d-flex">
              <a
                class="link-btn ml-auto"
                (click)="ScopeOfDelivery.openModal1()"
                >{{ helper.button.deli_area_link | translate }}</a
              >
            </div>
          </div>
          <div class="deli-add-bottom">
            <h3 *ngIf="!helper.common_data.cart_data.ipickup_delivery">
              {{ helper.text.deli_add_text2 | translate }}
            </h3>
            <h3 *ngIf="helper.common_data.cart_data.ipickup_delivery">
              {{ helper.text.deli_add_text3 | translate }}
            </h3>
            <p
              *ngIf="current_store.is_only_schedule_order"
              class="stop_order_p"
            >
              <span
                >Uniquement en précommande min.
                {{ current_store.only_schedule_order_after_hour }}h à
                l’avance.</span
              >
            </p>
            <div
              class="toggle-large-btn"
              [hidden]="
                helper.website_data.detail.is_close_asap &&
                helper.common_data.cart_data.is_schedule_order &&
                ((!helper.website_data.detail.is_pickup_possible &&
                  helper.common_data.cart_data.ipickup_delivery) ||
                  (!helper.website_data.detail.is_delivery_possible &&
                    !helper.common_data.cart_data.ipickup_delivery) ||
                  current_store.is_only_schedule_order)
              "
            >
              <div class="t-b-l d-flex align-items-center">
                <button
                  type="button"
                  class="primary-btn first"
                  (click)="
                    delivery_setting_service.change_schedule(
                      false,
                      current_store
                    )
                  "
                  [class.secondary-btn]="
                    helper.common_data.cart_data.is_schedule_order
                  "
                >
                  {{ helper.button.des_que_possible | translate }}
                </button>
                <button
                  class="primary-btn second"
                  (click)="set_schedule()"
                  [class.secondary-btn]="
                    !helper.common_data.cart_data.is_schedule_order
                  "
                  type="button"
                >
                  {{ helper.button.plus_tard | translate }}
                </button>
              </div>
            </div>

            <div
              class="order-deli-time"
              *ngIf="
                !helper.common_data.cart_data.is_schedule_order &&
                delivery_setting_service.delivered_time &&
                !current_store.close
              "
            >
              <p *ngIf="!helper.common_data.cart_data.ipickup_delivery">
                {{ helper.text.order_deli_time | translate
                }}<span>{{ delivery_setting_service.delivered_time }}</span>
              </p>
              <p *ngIf="helper.common_data.cart_data.ipickup_delivery">
                {{ helper.text.order_deli_time1 | translate
                }}<span>{{ delivery_setting_service.delivered_time }}</span>
              </p>
            </div>
            <div
              class="hour-time-section d-flex align-items-top"
              *ngIf="helper.common_data.cart_data.is_schedule_order"
            >
              <div class="date-dropdown">
                <label for="">{{ helper.label.date | translate }}</label>
                <div class="d-wrp">
                  <button
                    class="primary-btn d-dropdown"
                    (click)="
                      delivery_setting_service.is_show_date =
                        !delivery_setting_service.is_show_date
                    "
                    [class.active]="delivery_setting_service.is_show_date"
                  >
                    {{ delivery_setting_service.clicked_date }}
                    <svg
                      width="14"
                      height="9"
                      viewBox="0 0 14 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 1L7 7L13 1"
                        stroke="black"
                        stroke-width="2.25"
                      />
                    </svg>
                  </button>
                  <ul
                    class="dropdown-menu-list v-scroll-hide"
                    *ngIf="delivery_setting_service.is_show_date"
                  >
                    <li
                      *ngFor="let date of delivery_setting_service.date_array"
                      (click)="
                        delivery_setting_service.set_date(date, current_store)
                      "
                    >
                      {{ date.date_format }}
                    </li>
                  </ul>
                </div>
              </div>
              <div class="date-dropdown hour-dropdown">
                <label for="">{{ helper.label.heure | translate }}</label>
                <div class="d-wrp">
                  <button
                    class="primary-btn d-dropdown"
                    (click)="
                      delivery_setting_service.select_time(current_store)
                    "
                    [class.active]="delivery_setting_service.is_show_time"
                  >
                    {{ delivery_setting_service.schedule_time }}
                    <svg
                      width="14"
                      height="9"
                      viewBox="0 0 14 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 1L7 7L13 1"
                        stroke="black"
                        stroke-width="2.25"
                      />
                    </svg>
                  </button>
                  <ul
                    class="dropdown-menu-list v-scroll-hide"
                    *ngIf="delivery_setting_service.is_show_time"
                  >
                    <li
                      *ngFor="let time of delivery_setting_service.time_array"
                      (click)="
                        delivery_setting_service.set_time(time, current_store)
                      "
                    >
                      {{ time.time_format }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              class="pre-order-only"
              *ngIf="
                (current_store.close &&
                  !current_store.is_pickup_possible &&
                  helper.common_data.cart_data.ipickup_delivery) ||
                (!current_store.is_delivery_possible &&
                  !helper.common_data.cart_data.ipickup_delivery)
              "
            >
              <p *ngIf="current_store.nextopentime">
                {{ helper.text.pre_order_only | translate }}
                {{ helper.label.reouverture | translate }}
                {{ current_store.nextopentime }}
                <span *ngIf="current_store.next_order_time"
                  ><br />{{ helper.title.order_at | translate }}
                  {{ current_store.next_order_time }}
                </span>
              </p>

              <p *ngIf="!current_store.nextopentime">
                {{ helper.title.reopen_at | translate }}
                {{ helper.title.store_closed_today }}
              </p>
            </div>
            <div
              class="pre-order-only"
              *ngIf="
                !current_store.close &&
                delivery_setting_service.is_schedule_order &&
                delivery_setting_service.schedule_time_error &&
                (!current_store.is_delivery_stop_admin ||
                  helper.common_data.cart_data.ipickup_delivery)
              "
            >
              <p>{{ helper.title.schedule_time_error | translate }}</p>
            </div>
            <div
              class="pre-order-only"
              *ngIf="
                current_store.is_delivery_stop_admin && current_store.close
              "
            >
              <p>{{ helper.title.emergency_time_error | translate }}</p>
            </div>
          </div>
        </div>

        <div class="home-cont-footer">
          <button (click)="go_to_shop_page()" class="primary-btn">
            {{ helper.button.continuer | translate }}
          </button>
        </div>
      </div>

      <div
        class="open-time-btn menu-plus ml-auto"
        style="left: 17px; position: absolute"
        [class.active]="is_language_dropdown"
      >
        <button
          class="primary-btn"
          (click)="is_language_dropdown = !is_language_dropdown"
        >
          {{ helper.website_data.selected_language | translate }}
          <svg
            width="13"
            height="9"
            viewBox="0 0 13 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1 1L6.5 7L12 1" stroke-width="2" />
          </svg>
        </button>
        <ul
          class="v-scroll-hide"
          *ngIf="is_language_dropdown"
          style="left: 0; width: 100px; text-align: center"
        >
          <li
            *ngFor="
              let product of helper.website_data.language_list;
              let index = index
            "
            [class.active]="
              product.code == helper.website_data.selected_language
            "
            (click)="
              helper.select_language(product.code, index);
              is_language_dropdown = false
            "
          >
            <a>{{ product.code }}</a>
          </li>
        </ul>
      </div>

      <div
        class="delivery-area-link"
        *ngIf="
          (page_type == 2 || page_type == 1) &&
          helper.website_data.detail.is_business &&
          helper.website_data.detail.is_approved
        "
      >
        <a (click)="ScopeOfDelivery.openModal1()" class="blank_a">{{
          helper.button.delivery_area_link | translate
        }}</a>
      </div>

      <div
        class="open-time-btn"
        *ngIf="
          helper.website_data.detail.is_business &&
          helper.website_data.detail.is_approved
        "
        (clickOutside)="is_show_time_popup = false"
      >
        <div class="timetable-list d-flex" *ngIf="is_show_time_popup">
          <div
            class="timetable-close ml-auto"
            (click)="is_show_time_popup = false"
          >
            <span
              ><svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.40203 7.42927C9.32588 7.24648 9.21429 7.08058 9.0737 6.94113L7.1237 5.00613L9.0737 3.07113C9.35615 2.78868 9.51483 2.40559 9.51483 2.00614C9.51483 1.60668 9.35615 1.22359 9.0737 0.941136C8.79124 0.658681 8.40815 0.5 8.0087 0.5C7.60924 0.5 7.22615 0.658681 6.9437 0.941136L5.0087 2.89113L3.0737 0.941136C2.79124 0.658681 2.40815 0.5 2.0087 0.5C1.60925 0.5 1.22615 0.658681 0.943697 0.941136C0.661241 1.22359 0.502561 1.60668 0.502561 2.00614C0.502561 2.40559 0.661241 2.78868 0.943697 3.07113L2.8937 5.00613L0.943697 6.94113C0.803104 7.08058 0.691513 7.24648 0.61536 7.42927C0.539207 7.61206 0.5 7.80812 0.5 8.00613C0.5 8.20415 0.539207 8.40021 0.61536 8.583C0.691513 8.76579 0.803104 8.93169 0.943697 9.07113C1.08314 9.21173 1.24904 9.32332 1.43183 9.39947C1.61462 9.47562 1.81068 9.51483 2.0087 9.51483C2.20672 9.51483 2.40277 9.47562 2.58556 9.39947C2.76835 9.32332 2.93425 9.21173 3.0737 9.07113L5.0087 7.12113L6.9437 9.07113C7.08314 9.21173 7.24904 9.32332 7.43183 9.39947C7.61462 9.47562 7.81068 9.51483 8.0087 9.51483C8.20671 9.51483 8.40277 9.47562 8.58556 9.39947C8.76835 9.32332 8.93425 9.21173 9.0737 9.07113C9.21429 8.93169 9.32588 8.76579 9.40203 8.583C9.47819 8.40021 9.5174 8.20415 9.51739 8.00613C9.5174 7.80812 9.47819 7.61206 9.40203 7.42927Z"
                />
              </svg>
            </span>
          </div>
          <ul>
            <li
              class="d-flex align-items-center"
              *ngFor="let time of helper.website_data.detail.store_time"
              [class.active]="time.is_current_day"
            >
              <div class="days-name">
                <span>{{ helper.label[time.day] | translate }}</span>
                <span
                  class="light-btn"
                  [class.red]="helper.website_data.detail.close"
                  *ngIf="time.is_current_day"
                ></span>
              </div>
              <div class="days-time ml-auto">
                <div class="time-list">
                  <span *ngIf="time.is_store_open">
                    <span *ngFor="let time of time.day_time; let last = last"
                      >{{
                        time.store_open_time1
                          | date : helper.website_data.time_format
                      }}
                      -
                      {{
                        time.store_close_time1
                          | date : helper.website_data.time_format
                      }}
                    </span>
                  </span>
                  <span
                    *ngIf="time.day_time.length == 0 || !time.is_store_open"
                    >{{ helper.label.ferme | translate }}</span
                  >
                </div>
              </div>
            </li>
          </ul>
        </div>

        <ng-container
          *ngFor="let time of helper.website_data.detail.store_time"
        >
          <div
            class="open-t-b-w d-flex align-items-center ml-auto"
            (click)="is_show_time_popup = !is_show_time_popup"
            *ngIf="time.is_current_day"
          >
            <span
              class="light-btn"
              [class.red]="helper.website_data.detail.close"
            ></span>
            <span
              class="open-heading"
              *ngIf="!helper.website_data.detail.close"
              >{{ helper.title.ouvert | translate }}</span
            >
            <span
              class="open-heading red"
              *ngIf="helper.website_data.detail.close"
              >{{ helper.label.ferme | translate }}</span
            >
            <div class="time-list">
              <span *ngIf="!helper.website_data.detail.close">
                <span *ngFor="let time of time.day_time; let last = last"
                  >{{
                    time.store_open_time1
                      | date : helper.website_data.time_format
                  }}
                  -
                  {{
                    time.store_close_time1
                      | date : helper.website_data.time_format
                  }}
                </span>
              </span>
              <span *ngIf="helper.website_data.detail.close">
                <span *ngIf="helper.website_data.detail.nextopentime"
                  >{{ helper.label.reouverture | translate }}
                  {{ helper.website_data.detail.nextopentime }}</span
                >
                <span *ngIf="!helper.website_data.detail.nextopentime"
                  >{{ helper.title.reopen_at | translate }}
                  {{ helper.title.store_closed_today }}</span
                >
              </span>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div
    class="home-footer d-flex"
    *ngIf="current_store.is_show_email || current_store.is_show_phone"
  >
    <div class="email-btn" *ngIf="current_store.is_show_phone">
      <a target="_blank" href="mailto:{{ helper.website_data.detail.email }}">
        <button class="primary-btn secondary-btn svg-left">
          <span
            ><svg
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_2000_508)">
                <path
                  d="M7.94947 3.78848C9.15589 3.78848 10.2927 4.32329 11.1258 5.15934V5.16181C11.1258 4.76033 11.3959 4.45662 11.7692 4.45662H11.864C12.4532 4.45662 12.5712 5.01218 12.5712 5.18749L12.5737 11.427C12.5327 11.8359 12.9959 12.0472 13.2532 11.7845C14.2532 10.7559 15.4517 6.49119 12.6305 4.02206C9.99935 1.71736 6.46799 2.0981 4.59046 3.39193C2.5949 4.7707 1.31935 7.81613 2.55836 10.6784C3.91145 13.7988 7.77959 14.7297 10.0818 13.8013C11.2472 13.3307 11.7845 14.904 10.5732 15.4191C8.74749 16.1979 3.65959 16.1184 1.2833 12.0033C-0.322133 9.22354 -0.237195 4.33366 4.02256 1.80033C7.27836 -0.138933 11.5742 0.398352 14.1638 3.10206C16.87 5.93119 16.7134 11.2245 14.0714 13.2823C12.8749 14.2181 11.0981 13.308 11.111 11.9445L11.0976 11.5001C10.2645 12.3253 9.15589 12.8092 7.94947 12.8092C5.5628 12.8092 3.46157 10.7075 3.46157 8.32329C3.46157 5.91341 5.5628 3.78946 7.94947 3.78946V3.78848ZM10.9514 8.15094C10.8611 6.40428 9.56478 5.35243 7.99836 5.35243H7.9391C6.13367 5.35243 5.13071 6.77465 5.13071 8.38699C5.13071 10.1949 6.34206 11.3366 7.93169 11.3366C9.70601 11.3366 10.871 10.0384 10.9559 8.50255L10.9514 8.15094Z"
                />
              </g>
              <defs>
                <clipPath id="clip0_2000_508">
                  <rect
                    width="15.8025"
                    height="15.8025"
                    transform="translate(0.321289 0.321106)"
                  />
                </clipPath>
              </defs></svg
          ></span>
          {{
            current_store.contact_email
              ? current_store.contact_email
              : current_store.email
          }}
        </button>
      </a>
    </div>
    <div class="email-btn ml-auto" *ngIf="current_store.is_show_phone">
      <a
        target="_blank"
        href="tel:{{ helper.website_data.detail.country_phone_code }}{{
          helper.website_data.detail.phone
        }}"
      >
        <button class="primary-btn secondary-btn svg-left">
          <span
            ><svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.892187 2.1472L2.34824 0.692517C2.45095 0.589354 2.57304 0.507501 2.70748 0.45166C2.84192 0.39582 2.98606 0.367092 3.13164 0.367126C3.42832 0.367126 3.70723 0.483337 3.91641 0.692517L5.4832 2.25931C5.58637 2.36203 5.66822 2.48411 5.72406 2.61855C5.7799 2.75299 5.80863 2.89714 5.80859 3.04271C5.80859 3.33939 5.69238 3.6183 5.4832 3.82748L4.3375 4.97318C4.60568 5.5643 4.97854 6.10205 5.43809 6.56049C5.89647 7.02114 6.43418 7.39536 7.02539 7.66517L8.17109 6.51947C8.2738 6.41631 8.39589 6.33445 8.53033 6.27861C8.66477 6.22277 8.80892 6.19405 8.95449 6.19408C9.25117 6.19408 9.53008 6.31029 9.73926 6.51947L11.3074 8.0849C11.4107 8.1878 11.4926 8.31011 11.5485 8.44479C11.6043 8.57947 11.633 8.72387 11.6328 8.86967C11.6328 9.16635 11.5166 9.44525 11.3074 9.65443L9.8541 11.1078C9.52051 11.4427 9.05976 11.6328 8.58672 11.6328C8.48691 11.6328 8.39121 11.6245 8.29687 11.6081C6.45391 11.3046 4.62598 10.3244 3.15078 8.85052C1.67695 7.37806 0.698046 5.5515 0.390429 3.70306C0.297461 3.13842 0.484765 2.55736 0.892187 2.1472Z"
              />
            </svg>
          </span>
          {{ helper.website_data.detail.country_phone_code
          }}{{
            current_store.contact_phone
              ? current_store.contact_phone
              : current_store.phone
          }}
        </button>
      </a>
    </div>
  </div>
</div>

<ng-template #SeeMenu let-modal>
  <button
    type="button"
    class="close pull-right"
    aria-label="Close"
    (click)="modal.dismiss('Cross click')"
  >
    <span aria-hidden="true"
      ><svg
        width="14"
        height="15"
        viewBox="0 0 14 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.641964 4.44674C0.27079 4.07556 0.0852035 3.64252 0.0852036 3.14762C0.0852039 2.65272 0.270791 2.21969 0.641965 1.84851C1.01314 1.47734 1.43844 1.29948 1.91788 1.31495C2.39731 1.33042 2.82261 1.52374 3.19379 1.89491L12.6355 11.3367C13.0067 11.7078 13.1923 12.1409 13.1923 12.6358C13.2078 13.1152 13.0299 13.5405 12.6587 13.9117C12.2876 14.2829 11.8545 14.4684 11.3596 14.4684C10.8802 14.453 10.4549 14.2597 10.0837 13.8885L0.641964 4.44674ZM0.804354 13.6565C0.371317 13.2235 0.147065 12.7208 0.1316 12.1486C0.1316 11.5918 0.348119 11.0969 0.781156 10.6639L9.82853 1.61653C10.2616 1.18349 10.7642 0.974707 11.3364 0.990173C11.9087 1.00564 12.4113 1.22989 12.8443 1.66293C13.2928 2.11143 13.5093 2.60633 13.4939 3.14763C13.4939 3.70439 13.2774 4.19929 12.8443 4.63232L3.79695 13.6797C3.36391 14.1127 2.86901 14.3293 2.31225 14.3293C1.75549 14.3293 1.25286 14.105 0.804354 13.6565Z"
        /></svg
    ></span>
  </button>

  <div class="modal-body">
    <div class="modal-body-wrp">
      <div class="see-menu-title">
        <h3>{{ helper.text.see_menu_title | translate }}</h3>
        <p>{{ helper.text.see_menu_text | translate }}</p>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div
      class="modal-footer-wrp d-flex align-items-center justify-content-center"
    >
      <div class="popup-footer-btn">
        <button class="primary-btn">
          {{ helper.button.fermer | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #AlertPopup let-modal>
  <button
    type="button"
    class="close pull-right"
    aria-label="Close"
    (click)="modal.dismiss('Cross click')"
  >
    <span aria-hidden="true"
      ><svg
        width="14"
        height="15"
        viewBox="0 0 14 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.641964 4.44674C0.27079 4.07556 0.0852035 3.64252 0.0852036 3.14762C0.0852039 2.65272 0.270791 2.21969 0.641965 1.84851C1.01314 1.47734 1.43844 1.29948 1.91788 1.31495C2.39731 1.33042 2.82261 1.52374 3.19379 1.89491L12.6355 11.3367C13.0067 11.7078 13.1923 12.1409 13.1923 12.6358C13.2078 13.1152 13.0299 13.5405 12.6587 13.9117C12.2876 14.2829 11.8545 14.4684 11.3596 14.4684C10.8802 14.453 10.4549 14.2597 10.0837 13.8885L0.641964 4.44674ZM0.804354 13.6565C0.371317 13.2235 0.147065 12.7208 0.1316 12.1486C0.1316 11.5918 0.348119 11.0969 0.781156 10.6639L9.82853 1.61653C10.2616 1.18349 10.7642 0.974707 11.3364 0.990173C11.9087 1.00564 12.4113 1.22989 12.8443 1.66293C13.2928 2.11143 13.5093 2.60633 13.4939 3.14763C13.4939 3.70439 13.2774 4.19929 12.8443 4.63232L3.79695 13.6797C3.36391 14.1127 2.86901 14.3293 2.31225 14.3293C1.75549 14.3293 1.25286 14.105 0.804354 13.6565Z"
        /></svg
    ></span>
  </button>

  <div class="modal-body">
    <div class="modal-body-wrp">
      <div class="alert-icon">
        <svg
          width="41"
          height="35"
          viewBox="0 0 41 35"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.9985 32.6172L21.7173 0.976562C21.4448 0.506348 20.9746 0.273438 20.5 0.273438C20.0254 0.273438 19.5508 0.506348 19.2827 0.976562L1.00148 32.6172C0.460952 33.5576 1.13771 34.7266 2.21876 34.7266H38.7813C39.8623 34.7266 40.5391 33.5576 39.9985 32.6172ZM19.0938 13.2812C19.0938 13.0879 19.252 12.9297 19.4453 12.9297H21.5547C21.7481 12.9297 21.9063 13.0879 21.9063 13.2812V21.3672C21.9063 21.5605 21.7481 21.7188 21.5547 21.7188H19.4453C19.252 21.7188 19.0938 21.5605 19.0938 21.3672V13.2812ZM20.5 28.75C19.948 28.7387 19.4225 28.5115 19.0361 28.1172C18.6497 27.7228 18.4333 27.1927 18.4333 26.6406C18.4333 26.0885 18.6497 25.5584 19.0361 25.1641C19.4225 24.7697 19.948 24.5425 20.5 24.5312C21.052 24.5425 21.5776 24.7697 21.964 25.1641C22.3504 25.5584 22.5668 26.0885 22.5668 26.6406C22.5668 27.1927 22.3504 27.7228 21.964 28.1172C21.5776 28.5115 21.052 28.7387 20.5 28.75Z"
          />
        </svg>
      </div>
      <div class="alert-text">
        <p>{{ helper.text.alert_text1 | translate }}</p>
        <p>{{ helper.text.alert_text2 | translate }}</p>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div
      class="modal-footer-wrp d-flex align-items-center justify-content-center"
    >
      <div class="popup-footer-btn">
        <button class="primary-btn">
          {{ helper.button.ok_ai_compris | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Alert popup end  -->
<app-login-register-modal
  #AccountPopup
  [is_second_text]="true"
  [login_header_text]="helper.text.pay_text1"
  [is_register_button]="true"
></app-login-register-modal>
<app-delivery-error-modal #ScopeOfDelivery></app-delivery-error-modal>
